import gql from 'graphql-tag';
import client from '../graphqlAPI';

const GET_LOYALTY_RANKING = gql`
  query getLoyaltyRanking($email: String, $type: String, $slug: String, $claimed: String, $startDate: String, $finishDate: String, $from: Int, $to: Int, $sortingField: String, $sortingType: Int, $getTotal: Boolean) {
    getLoyaltyRanking(email: $email, type: $type, slug: $slug, claimed: $claimed, startDate: $startDate, finishDate: $finishDate, from: $from, to: $to, sortingField: $sortingField, sortingType: $sortingType, getTotal: $getTotal) {
      isAuth
      total
      query
      asOf
      items { email name totalPoints achievementsCount prizesCount prizesClaimedCount lastActivityAt }
    }
  }
`;

const getLoyaltyRanking = async (variables) => {
  try {
    const result = await client.query({
      query: GET_LOYALTY_RANKING, variables, errorPolicy: 'all', fetchResults: true, fetchPolicy: 'no-cache',
    }).catch((queryError) => {
      console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getLoyaltyRanking Query Error: ${queryError}`);
      return null;
    });
    return result && result.data ? result.data.getLoyaltyRanking : null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getLoyaltyRanking Error: ${error}`);
    return null;
  }
};

export default getLoyaltyRanking;
